__webpack_require__.p = "//jsak.mmtcdn.com/tripmoney/apps/forex-landing/_next/";